export const MAINTENANCE_SETTING_KEY = 'MAINTENANCE_MODE';

/**
 * MaintenanceStatus Model
 * Normalizes the public maintenance status response.
 */
export class MaintenanceStatus {
    constructor(data = {}) {
        this.enabled = Boolean(data.enabled);
        this.message = data.message || null;
    }
}
